import React, { useContext, useEffect, useState } from "react";
import AppContext from "../contexts/AppContext";
import { Auth, Hub } from "aws-amplify";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Hidden from "@material-ui/core/Hidden";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
// @material-ui/icons components
import DirectionsRun from "@material-ui/icons/DirectionsRun";
import Settings from "@material-ui/icons/Settings";
import { useUsers } from "../hooks/useUsers";

import componentStyles from "../assets/styles/components/navbar_dropdown";
import CustomAvatar from "./atoms/custom_avatar";
const useStyles = makeStyles(componentStyles);

export default function NavbarDropdown() {
  const { state, dispatch } = useContext(AppContext);
  const { getUser, init } = useUsers();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const isMenuOpen = Boolean(anchorEl);

  useEffect(() => {
    Hub.listen("auth", (data) => {
      switch (data.payload.event) {
        case "signIn":
          getUserByCurrentUserId();
          break;
        default:
      }
    });
  }, []);

  useEffect(() => {
    getUserByCurrentUserId();
  }, [state.current]);

  const getUserByCurrentUserId = () => {
    const currentUserId = state.current.user?.id;
    if (
      currentUserId &&
      !state.users?.some((existUser) => existUser.id === currentUserId)
    ) {
      getUser({
        id: currentUserId,
        apikey: state.current.apikey,
        redmineurl: state.current.redmineurl,
      });
    }
  };

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    setAnchorEl(null);
    Auth.signOut();
  };

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <Box
        display="flex!important"
        alignItems="center!important"
        component={MenuItem}
        onClick={handleLogout}
      >
        <Box
          component={DirectionsRun}
          width="1.25rem!important"
          height="1.25rem!important"
          marginRight="1rem"
        />
        <span>Logout</span>
      </Box>
    </Menu>
  );

  return (
    <>
      <Button
        edge="end"
        aria-label="account of current user"
        aria-controls={menuId}
        aria-haspopup="true"
        onClick={handleProfileMenuOpen}
        color="inherit"
        classes={{
          label: classes.buttonLabel,
          root: classes.buttonRoot,
        }}
      >
        <CustomAvatar
          alt="..."
          classes={{
            root: classes.avatarRoot,
          }}
          userId={state.current.user?.id}
          redmineurl={state.current?.redmineurl}
        >
          {state.navbar.authCurrentUser
            ? state.navbar.authCurrentUser.slice(0, 2)
            : ""}
        </CustomAvatar>
        <Hidden smDown>
          {state.navbar.authCurrentUser ? state.navbar.authCurrentUser : ""}
        </Hidden>
      </Button>
      {renderMenu}
    </>
  );
}
